<template>
  <div class="banner">
    <div class="titleSub">NEWS</div>
    <div class="title wow animate__animated durationTime animate__fadeInUp">新闻动态</div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
export default {
  data() {
    return {};
  },
  computed: {},
  mounted() {
    // init wow
    const wow = new WOW({
      boxClass: "wow", //需要执行动画元素的Class
      animateClass: "animated_lightSpeedIn", //animation.css动画的Class
      offset: 0, //距离可视区域多少开始执行动画
      mobile: true, //是否在移动设备执行动画
      live: true //异步加载的内容是否有效
    });
    wow.init();
  },
  methods: {}
};
</script>

<style scoped lang="scss">
.banner {
  width: 100%;
  height: 5.8rem;
  background: url(../../../assets/image/news/banbg.png) center no-repeat;
  background-size: cover;
  .title {
    font-size: 0.44rem;
    font-weight: 500;
    text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    margin-top: 2.75rem;
    margin-left: 2.18rem;
    position: relative;
    color: #fff;
    display: inline-block;
  }
  .titleSub {
      content: "NEWS";
      position: absolute;
      margin-top: 2.44rem;
    margin-left: 2.41rem;
      font-size: 0.44rem;
      font-weight: 500;
    color: rgb(169 160 160 / 51%);
      text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      letter-spacing: 0.02rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/news/components/banner.vue